import { Icon, IconProps } from "@chakra-ui/react";

export function HeroMaskBlackFridayIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 1529 799"
      sx={{
        "& svg": {
          preserveAspectRatio: "xMidYMid meet",
        },
      }}
      {...props}
    >
      <path
        d="M1451.58 0.5H61.1596C27.0951 0.5 -0.290555 28.5432 0.517612 62.5981L13.4531 607.679C14.3625 646.002 43.5098 677.728 81.6187 681.876L1145.38 797.651C1172.89 800.645 1199.87 788.538 1215.93 765.994L1513.86 347.642C1523.09 334.691 1528.04 319.188 1528.04 303.288V76.9597C1528.04 34.7322 1493.81 0.5 1451.58 0.5Z"
        stroke="url(#paint0_linear_5491_8140)"
        strokeOpacity="0.7"
        fill="transparent"
      />
      <defs>
        <linearGradient 
          id="paint0_linear_5491_8140" 
          x1="1528.04" 
          y1="397.385" 
          x2="-0.956055" 
          y2="397.385" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0"/>
          <stop offset="0.658654" stopColor="white" stopOpacity="0.6"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
      </defs>
    </Icon>
  );
}
